export default (function (_ref) {
  var request = _ref.request;
  return {
    oemDeviceTaskAdd: function oemDeviceTaskAdd(data) {
      return request({
        url: '/monitor/oemDeviceTask/add',
        method: 'post',
        data: data
      });
    },
    oemDeviceTaskModify: function oemDeviceTaskModify(data) {
      return request({
        url: "/monitor/oemDeviceTask/".concat(data.id, "/modify"),
        method: 'put',
        data: data
      });
    },
    oemDeviceTaskEnd: function oemDeviceTaskEnd(data) {
      return request({
        url: "/monitor/oemDeviceTask/".concat(data.id, "/end"),
        method: 'put',
        data: data
      });
    },
    oemDeviceTaskDiscard: function oemDeviceTaskDiscard(data) {
      return request({
        url: "/monitor/oemDeviceTask/".concat(data.id, "/discard"),
        method: 'put',
        data: data
      });
    },
    oemDeviceTaskDel: function oemDeviceTaskDel(id) {
      return request({
        url: "/monitor/oemDeviceTask/".concat(id, "/del"),
        method: 'delete'
      });
    },
    oemDeviceTaskQuery: function oemDeviceTaskQuery(data) {
      return request({
        url: '/monitor/oemDeviceTask/query',
        method: 'get',
        params: data
      });
    },
    oemDeviceTaskDetail: function oemDeviceTaskDetail(id) {
      return request({
        url: "/monitor/oemDeviceTask/".concat(id, "/detail"),
        method: 'get'
      });
    }
  };
});